import React from "react";
import {Card, Dialog, DialogContent, IconButton, Tooltip, withStyles} from "@material-ui/core";
import {makeFitImageUrl, makeFitImageUrlWithSize, makeWaveformUrl} from "../../../utils";
import {ArrowBackIosRounded, ArrowForwardIosRounded, Close, Share} from "@material-ui/icons";
import styled from "styled-components";
import ShakaPlayer from "../ShakaPlayer";
import SoundBar from "../../../sound-bar/SoundBar";
import {makeImageUrlWithSize} from "../../../layouts/Home/HomeElements/utils";
import EmbededContent from "../../../layouts/Home/ContentCreator/EmbededContent";
import EventManager, {events} from "../../../utils/EventManager";
import './index.css'
import {request} from "../../../api-client";
import AddToPlaylist from "../AddToPlaylist";
import ShareOnSocials from "../ShareOnSocials";
import AudioImage from "../../../assets/img/Letflow/SmartSearch/audio.png";
import NoProfile from "../../../assets/img/default-avatar.png";
import NoImage from "../../../assets/img/Letflow/FileExtentions/zip.png";
import BloomSpinner from "../../../assets/img/bloom_spinner_grey.gif";

import localization from "../../../config/localization";
import { addHttpsToUrl, homePathGenerator } from "../../../api-client/core/authentication/utils";
import { Link } from "react-router-dom";
import {ReactComponent as Star} from "../../../components/Letflow/SvgIcons/star.svg"
import {ReactComponent as List} from "../../../components/Letflow/SvgIcons/list.svg"

const styles = {
  dialogPaper: {
      minHeight: '100vh',
      minWidth: '100vw',
      maxHeight: '100vh',
      maxWidth: '100vw',
      backgroundColor: "rgba(0,0,0,0.8)",
      padding: '40px',
      height: '100vh',
      width: '100vw'
  },
  dialogPaperMobile: {
    minHeight: '80vh',
    maxHeight: '80vh',
    backgroundColor: '#EFEFEF',
    borderRadius: '10px',
    padding: '20px',
    height: '80vh',
    fontSize: '0.8em'
  }
};

const StyledTooltip = withStyles({
  tooltipPlacementTop: {
    margin: "4px 0",
  },
})(Tooltip);

class ContentCreationPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.state = {
      currentContentCreation: this.props.currentContentCreation,
      autoPlay: false,
      shareToken: "",
      hidden: true,
      noAuthorLink: this.props.noAuthorLink
    }
    this.soundbarRef = null;
    window.addEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(e) {
    // arrow up/down button should select next/previous list element
    if (e.keyCode === 37 && this.props.onPrevArrow) {
      this.handlePrevArrow();
    } else if (e.keyCode === 39 && this.props.onNextArrow) {
      this.handleNextArrow();
    }
  }


  getAudio = currentContentCreation => {
    return {
      id: currentContentCreation.id,
      fetchAudioUrl: () => Promise.resolve(currentContentCreation.audio.url),
      title: currentContentCreation.title,
      subtitle: currentContentCreation.contentCreator && currentContentCreation.contentCreator.name,
      image: currentContentCreation.contentCreator ? makeImageUrlWithSize(currentContentCreation.contentCreator, 'xs') : makeImageUrlWithSize(currentContentCreation, 'xs'),
      waveform: makeWaveformUrl(currentContentCreation),
    }
  }

  componentWillReceiveProps(nextProps) {
    let showContent = nextProps.currentContentCreation && (nextProps.currentContentCreation.video || nextProps.currentContentCreation.embededContent || nextProps.currentContentCreation.audio);
    if (!nextProps.currentContentCreation) {
      this.setState({currentContentCreation: null, hidden: true});
    } else if (!this.props.currentContentCreation) {
      this.setState({currentContentCreation: null, hidden: true}, () => this.setState({currentContentCreation: nextProps.currentContentCreation, hidden: !showContent}))
    }else if (nextProps.currentContentCreation && this.props.currentContentCreation.id !==  nextProps.currentContentCreation.id) {
      this.setState({currentContentCreation: null, hidden: true}, () => this.setState({currentContentCreation: nextProps.currentContentCreation, hidden: !showContent}))
    }
    setTimeout(() => this.state.hidden && this.setState({hidden: false}), 5000);
  }


  componentWillUnmount = () => {
    window.removeEventListener("keydown", this.handleKeyDown);
    EventManager.getInstance().unsubscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToFavorites)
    EventManager.getInstance().unsubscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromFavorites)
  }

  onFavorite = (creation) => {
    if(!creation.favorite) {
      this.addToFavorites(creation.id)
    } else  {
      this.removeFromFavorites(creation.id)
    }
  }

  addToFavorites = () =>
    this.setState({
      currentContentCreation: {
        ...this.state.currentContentCreation,
        favorite: true,
      }
    }, () => request.contentCreationFavorite.add(this.state.currentContentCreation.id))


  removeFromFavorites = () =>
    this.setState({
      currentContentCreation: {
        ...this.state.currentContentCreation,
        favorite: false,
      }
    }, () => request.contentCreationFavorite.remove(this.state.currentContentCreation.id))

  handleClose = () => {
    this.soundbarRef && this.soundbarRef.stop();
    this.props.handleClose();
  } 

  handlePrevArrow = () => {
    this.soundbarRef && this.soundbarRef.stop();
    this.props.onPrevArrow && this.props.onPrevArrow();
  }
  handleNextArrow = () => {
    this.soundbarRef && this.soundbarRef.stop();
    this.props.onNextArrow && this.props.onNextArrow();
  }
  render() {
    let currentContentCreation = this.state.currentContentCreation
    // if (!currentContentCreation) {
    //   return (<></>)
    // }

    const { classes } = this.props;
    return (
      <Dialog 
        open={this.props.show} 
        fullScreen={true} 
        onClose={this.handleClose}
        onEscapeKeyDown={this.handleClose}
        classes={{paper: classes.dialogPaper}}
        onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.handleClose()}}
        disableEnforceFocus>
        <IconButton 
          className="content-creation-player-close" style={{position: "absolute", right: "calc(2% + 2px)", top: 5, color: "white", minWidth: 0, padding: "10px 10px", zIndex: "1"}} 
          onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.handleClose()}}>
            <Close style={{fontSize: 35}}/>
        </IconButton>
        {this.props.onPrevArrow && <div className="creation-player-left-arrow" onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.handlePrevArrow()}}><ArrowBackIosRounded style={{fontSize: 60, marginLeft: "-3px"}}/></div>}
        {this.props.onNextArrow && <div className="creation-player-right-arrow" onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.handleNextArrow()}}><ArrowForwardIosRounded style={{fontSize: 60, marginRight: "-5px"}}/></div>}
        {currentContentCreation &&
          <ShareOnSocials
          show={this.state.showShareDialog}
          handleClose={() => this.setState({showShareDialog: false})}
          url={`${window.location.protocol}//${window.location.hostname}/public/content_creations/${this.state.shareToken}`}
          darkMode={true}
          shareToken={this.state.shareToken}
          onClick={(e) => {e.stopPropagation(); e.preventDefault();}}
        />
        }
        {currentContentCreation && currentContentCreation.audio ? 
          <Card className="creation-player-audio-card" onClick={(e) => {e.stopPropagation(); e.preventDefault();}}>
            <div className="creation-player-audio">
              <div style={currentContentCreation.image ? {backgroundImage: `url(${makeImageUrlWithSize(currentContentCreation, 'md')})`} : {backgroundImage: `url(${AudioImage})`, backgroundPositionX: "center"}} className="creation-player-audio-image"/>
              <div className="creation-player-audio-info">
                <div className={"creation-player-audio-data"}>
                  {currentContentCreation.contentCreator && 
                    <div className={"creation-player-author"}>
                      {/* <div
                        className={"creation-player-author-image"}
                        style={{backgroundImage: `url(${!!currentContentCreation.contentCreator.image ? makeImageUrlWithSize(currentContentCreation.contentCreator, 'xs') : NoProfile})`}}
                      /> */}
                      {this.state.noAuthorLink ?
                        <a className="creation-player-author-name">{currentContentCreation.contentCreator.name}</a>
                        :
                        <Link
                        className={"creation-player-author-name"}
                        to={this.state.noAuthorLink ? null : homePathGenerator(this.props.isPublic ? `public/content_creators/${currentContentCreation.contentCreator.hashcode}` : `contenido/${currentContentCreation.contentCreator.id}-${currentContentCreation.contentCreator.name}`)}
                        onClick={e => {
                          this.soundbarRef && this.soundbarRef.stop();
                          if (this.props.onCreatorClick) {
                            this.props.onCreatorClick()
                          }   
                        }}
                        >{currentContentCreation.contentCreator.name}</Link>
                      }
                    </div>
                  }
                  <h3 style={{color: "black", margin: 0}}>{currentContentCreation.title}</h3>
                  <h3 style={{color: "black", fontWeight: "300", margin: 0}}>{currentContentCreation.description && (currentContentCreation.description.length > 100 ? currentContentCreation.description.substring(0,100).concat("...") : currentContentCreation.description)}</h3>
                  {currentContentCreation.tags && currentContentCreation.tags.length > 0 &&
                    <div className={"creation-tags"}>
                      <h3>Tags</h3>
                      {currentContentCreation.tags.slice(0,5).map((t) => (<div>{t.name}</div>))}
                    </div>
                  }
                </div>
                {!this.props.isPublic &&
                  <div style={{display: "flex", flexDirection: "row", width: 100, justifyContent: "flex-end"}} className="creation-player-audio-socials">
                    {!!currentContentCreation.favorite ?
                      <StyledTooltip placement="top" title={localization.get("soundbar.remove_from_favorites")}>
                        <Star
                          className="creation-player-fav-icon"
                          style={{cursor: "pointer", height: 24,width: 24, marginRight: 10}} onClick={this.removeFromFavorites}
                        />
                      </StyledTooltip>
                      :
                      <StyledTooltip placement="top" title={localization.get("soundbar.add_to_favorites")}>
                        <Star
                          className="creation-player-unfav-icon"
                          style={{cursor: "pointer", height: 24,width: 24, marginRight: 10}} onClick={this.addToFavorites}
                        />
                      </StyledTooltip>
                    }
                    <AddToPlaylist
                      id={currentContentCreation.id}
                      content={"contentCreations"}
                      icon={<StyledTooltip placement="top" title={localization.get("add_to_playlist")}>
                        <List className="creation-player-playlist" style={{cursor: "pointer", height: 22,width: 24, marginRight: 5, marginTop: 2}}/>
                      </StyledTooltip>}
                    />
                    <StyledTooltip placement="top" title={localization.get("share")}>
                      <Share
                        style={{fontSize: 24, fill: "black", cursor: "pointer", marginTop: 2, marginLeft: 5}}
                        onClick={() => request.contentCreation.share(currentContentCreation.id)
                          .then(response => this.setState({
                            showShareDialog: true,
                            shareToken: response.code
                          }))
                        }
                      />
                    </StyledTooltip>
                  </div>
                }
              </div>
            </div>
            <SoundBar style={{paddingTop: 10}} track={this.getAudio(currentContentCreation)} ref={r => this.soundbarRef = r}/>
          </Card>
        :
          currentContentCreation
          ?
            <div style={{padding:0, height: "100%", overflow: 'hidden', width: "100%", minWidth: 200, display: "grid", position: "relative", margin: "auto"}}>
              {this.state.hidden && <img style={{width: 80, height: 80, top: "calc(50% - 40px)", left: "calc(50% - 40px)", position: "absolute"}} src={BloomSpinner} alt="Loading logo"/>}
              <DialogContent className="content-creation-player-dialog" style={{padding: 0, height: "fit-content", maxHeight: "100%", overflow: 'hidden', maxWidth: "90%", display: this.state.hidden ? "none" : "flex", backgroundColor: "#EFEFEF", position: "relative", margin: "auto", flexDirection: "row"}} onClick={(e) => {e.stopPropagation(); e.preventDefault();}}>
                {currentContentCreation &&
                  <>
                    <div style={(currentContentCreation.video || currentContentCreation.embededContent) && {width: "fit-content", overflow: "hidden"}} className={"content-creation-player-video"}>
                      {currentContentCreation.video ?
                        <ShakaPlayer
                          video={currentContentCreation.video}
                          videoTitle={currentContentCreation.title}
                          subtitles={currentContentCreation.video.subtitles}
                          thumbnail={currentContentCreation.image ? makeFitImageUrlWithSize(currentContentCreation, 'lg') : makeFitImageUrlWithSize({image: currentContentCreation.video.thumbnail}, 'lg')}
                          preview={false}
                          styles={{width: "100%", minWidth: Math.floor((window.innerWidth - 80) * 0.9 - (window.innerWidth <= 650 ? 60 : 260))}}
                          autoPlay={false}
                          setAutoPlay={(value) => this.setState({autoPlay: value})}
                        />
                        : currentContentCreation.embededContent ?
                          <EmbededContent
                            content={currentContentCreation.embededContent}
                            index={currentContentCreation.id}
                            currentIndex={currentContentCreation.id}
                            width={Math.floor((window.innerWidth - 80) * 0.9 - (window.innerWidth <= 650 ? 60 : 260))}
                            height={Math.floor(((window.innerWidth - 80) * 0.9 - (window.innerWidth <= 650 ? 60 : 260)) / 1.75)}
                          /> :
                          currentContentCreation.image ?
                            <>
                              <img
                                src={currentContentCreation ? makeFitImageUrlWithSize (currentContentCreation, 'lg') : ''}
                                className={(currentContentCreation.binary || currentContentCreation.link) ? "content-creation-player-image content-creation-player-binary-image" : "content-creation-player-image"}
                                onLoad={() => setTimeout(() => this.setState({hidden: false}), 100)}
                              />
                              {(currentContentCreation.binary || currentContentCreation.link) && 
                                <div className="download-button-container">
                                  <span className="download-button" onClick={() => {currentContentCreation.link ? window.open(addHttpsToUrl(currentContentCreation.link, '_blank')) : window.open(currentContentCreation.binary.url, '_blank')}}>{localization.get("download")}</span>
                                </div>
                              }
                            </>
                            : 
                          currentContentCreation.binary ? 
                            <>
                              <img
                                src={NoImage}
                                className={"content-creation-player-image content-creation-player-binary-image"}
                                onLoad={() => setTimeout(() => this.setState({hidden: false}), 500)}
                              />
                              <div className="download-button-container">
                                <span className="download-button" onClick={() => {window.open(currentContentCreation.binary.url, '_blank')}}>{localization.get("download")}</span>
                              </div>
                            </>
                          : <></>
                      }
                    </div>
                    <div className={"creation-player-info"}>
                      {!this.props.isPublic &&
                      <div style={{display: "flex", flexDirection: "row"}}>
                        {!!currentContentCreation.favorite ?
                          <StyledTooltip placement="top" title={localization.get("soundbar.remove_from_favorites")}>
                            <Star
                              className="creation-player-fav-icon"
                              style={{cursor: "pointer", height: 24,width: 24, marginRight: 10}} onClick={this.removeFromFavorites}
                            />
                          </StyledTooltip>
                          :
                          <StyledTooltip placement="top" title={localization.get("soundbar.add_to_favorites")}>
                            <Star
                              className="creation-player-unfav-icon"
                              style={{cursor: "pointer", height: 24,width: 24, marginRight: 10}} onClick={this.addToFavorites}
                            />
                          </StyledTooltip>
                        }
                        <AddToPlaylist
                          id={currentContentCreation.id}
                          content={"contentCreations"}
                          creationPlayer={window.innerWidth > 650}
                          icon={<StyledTooltip placement="top" title={localization.get("add_to_playlist")}>
                            <List className="creation-player-playlist" style={{cursor: "pointer", height: 22,width: 24, marginRight: 5, marginTop: 2}}/>
                          </StyledTooltip>}
                        />
                        <StyledTooltip placement="top" title={localization.get("share")}>
                          <Share
                            style={{fontSize: 24, fill: "black", cursor: "pointer", marginTop: 2, marginLeft: 5}}
                            onClick={() => request.contentCreation.share(currentContentCreation.id)
                              .then(response => this.setState({
                                showShareDialog: true,
                                shareToken: response.code
                              }))
                            }
                          />
                        </StyledTooltip>
                      </div>
                      }
                      <div className={"creation-player-data"}>
                        {currentContentCreation.contentCreator && 
                          <div className={"creation-player-author"}>
                            {/* <div
                              className={"creation-player-author-image"}
                              style={{backgroundImage: `url(${!!currentContentCreation.contentCreator.image ? makeImageUrlWithSize(currentContentCreation.contentCreator, 'xs') : NoProfile})`}}
                            /> */}
                            {this.state.noAuthorLink ?
                              <a className="creation-player-author-name">{currentContentCreation.contentCreator.name}</a>
                            :
                              <Link
                                className={"creation-player-author-name"}
                                onClick={this.props.onCreatorClick ? () => this.props.onCreatorClick() : null}
                                to={this.state.noAuthorLink ? null : homePathGenerator(this.props.isPublic ? `public/content_creators/${currentContentCreation.contentCreator.hashcode}` : `contenido/${currentContentCreation.contentCreator.id}-${currentContentCreation.contentCreator.name}`)}
                              >{currentContentCreation.contentCreator.name}</Link>
                            }
                          </div>
                        }
                        <h3 style={{color: "black", margin: 0}}>{currentContentCreation.title}</h3>
                        <h3 style={{color: "black", fontWeight: "300", margin: 0}}>{currentContentCreation.description && ((currentContentCreation.tags && currentContentCreation.tags.length > 0 && currentContentCreation.description.length > 100) ? currentContentCreation.description.substring(0,100).concat("...") : currentContentCreation.description)}</h3>
                        {currentContentCreation.tags && currentContentCreation.tags.length > 0 &&
                          <div className={"creation-tags"}>
                            <h3>Tags</h3>
                            {currentContentCreation.tags.slice(0,7).map((t) => (<div>{t.name}</div>))}
                          </div>
                        }
                      </div>
                    </div>
                  </>
                }
              </DialogContent>
            </div>
          :
            null
        }
      </Dialog>
    )
  }
}

const AudioBar = styled.audio`
/*margin: 20px 2%;*/
@media (max-width: 440px) {
  width: 100%;
}
`;

export default withStyles(styles)(ContentCreationPlayer);